/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Bidding_N_Battles__Question_2Inputs */

const en_help_center__bidding_n_battles__question_2 = /** @type {(inputs: Help_Center__Bidding_N_Battles__Question_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many bids should I buy?`)
};

/**
* | output |
* | --- |
* | "How many bids should I buy?" |
*
* @param {Help_Center__Bidding_N_Battles__Question_2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__bidding_n_battles__question_2 = /** @type {((inputs?: Help_Center__Bidding_N_Battles__Question_2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Bidding_N_Battles__Question_2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__bidding_n_battles__question_2(inputs)
});